var _rect, _mask, _g, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCorrelationsEmptyState(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 144,
    height: 110,
    viewBox: "0 0 144 110",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 6,
    width: 78.3086,
    height: 78.3086,
    rx: 6,
    fill: "#E9E9F0"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "mask0",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 6,
    y: 0,
    width: 79,
    height: 79
  }, /*#__PURE__*/React.createElement("rect", {
    x: 6,
    width: 78.3086,
    height: 78.3086,
    rx: 6,
    fill: "#E9E9F0"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M77.334 82.983C81.2168 82.983 84.3644 79.8354 84.3644 75.9527C84.3644 72.0699 81.2168 68.9224 77.334 68.9224C73.4513 68.9224 70.3037 72.0699 70.3037 75.9527C70.3037 79.8354 73.4513 82.983 77.334 82.983Z",
    fill: "#E9F0FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.4723 49.3323C90.9524 49.3323 94.5842 45.7004 94.5842 41.2203C94.5842 36.7402 90.9524 33.1084 86.4723 33.1084C81.9922 33.1084 78.3604 36.7402 78.3604 41.2203C78.3604 45.7004 81.9922 49.3323 86.4723 49.3323Z",
    fill: "#C9DBFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.40795 66.7602C8.39468 66.7602 10.8159 64.339 10.8159 61.3523C10.8159 58.3656 8.39468 55.9443 5.40795 55.9443C2.42122 55.9443 0 58.3656 0 61.3523C0 64.339 2.42122 66.7602 5.40795 66.7602Z",
    fill: "#C9DBFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.9821 30.3757C78.1181 30.3757 80.6604 27.8335 80.6604 24.6974C80.6604 21.5613 78.1181 19.019 74.9821 19.019C71.846 19.019 69.3037 21.5613 69.3037 24.6974C69.3037 27.8335 71.846 30.3757 74.9821 30.3757Z",
    fill: "#C9DBFF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M60.0289 46.2082C64.509 46.2082 68.1409 42.5764 68.1409 38.0963C68.1409 33.6162 64.509 29.9844 60.0289 29.9844C55.5488 29.9844 51.917 33.6162 51.917 38.0963C51.917 42.5764 55.5488 46.2082 60.0289 46.2082Z",
    fill: "#F7FAFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.358 65.4338C72.8381 65.4338 76.47 61.802 76.47 57.3219C76.47 52.8418 72.8381 49.21 68.358 49.21C63.8779 49.21 60.2461 52.8418 60.2461 57.3219C60.2461 61.802 63.8779 65.4338 68.358 65.4338Z",
    fill: "#E9F0FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.0289 85.1462C64.509 85.1462 68.1409 81.5144 68.1409 77.0343C68.1409 72.5542 64.509 68.9224 60.0289 68.9224C55.5488 68.9224 51.917 72.5542 51.917 77.0343C51.917 81.5144 55.5488 85.1462 60.0289 85.1462Z",
    fill: "#C9DBFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.408 7.81591C65.3947 7.81591 67.8159 5.39468 67.8159 2.40795C67.8159 -0.578781 65.3947 -3 62.408 -3C59.4212 -3 57 -0.578781 57 2.40795C57 5.39468 59.4212 7.81591 62.408 7.81591Z",
    fill: "#C9DBFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17 83C20.3137 83 23 80.3137 23 77C23 73.6863 20.3137 71 17 71C13.6863 71 11 73.6863 11 77C11 80.3137 13.6863 83 17 83Z",
    fill: "#F7FAFF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M44.345 40.8003C47.3317 40.8003 49.7529 38.3791 49.7529 35.3923C49.7529 32.4056 47.3317 29.9844 44.345 29.9844C41.3582 29.9844 38.937 32.4056 38.937 35.3923C38.937 38.3791 41.3582 40.8003 44.345 40.8003Z",
    fill: "#F7FAFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.345 53.7798C47.3317 53.7798 49.7529 51.3586 49.7529 48.3718C49.7529 45.3851 47.3317 42.9639 44.345 42.9639C41.3582 42.9639 38.937 45.3851 38.937 48.3718C38.937 51.3586 41.3582 53.7798 44.345 53.7798Z",
    fill: "#C9DBFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.345 79.7383C47.3317 79.7383 49.7529 77.3171 49.7529 74.3303C49.7529 71.3436 47.3317 68.9224 44.345 68.9224C41.3582 68.9224 38.937 71.3436 38.937 74.3303C38.937 77.3171 41.3582 79.7383 44.345 79.7383Z",
    fill: "#C9DBFF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M18.9285 53.7798C21.9152 53.7798 24.3364 51.3586 24.3364 48.3718C24.3364 45.3851 21.9152 42.9639 18.9285 42.9639C15.9417 42.9639 13.5205 45.3851 13.5205 48.3718C13.5205 51.3586 15.9417 53.7798 18.9285 53.7798Z",
    fill: "#F7FAFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.48955 27.9791C11.0736 27.9791 13.9791 25.0736 13.9791 21.4895C13.9791 17.9055 11.0736 15 7.48955 15C3.90547 15 1 17.9055 1 21.4895C1 25.0736 3.90547 27.9791 7.48955 27.9791Z",
    fill: "#C9DBFF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M31.3669 79.7383C34.3537 79.7383 36.7749 77.3171 36.7749 74.3303C36.7749 71.3436 34.3537 68.9224 31.3669 68.9224C28.3802 68.9224 25.959 71.3436 25.959 74.3303C25.959 77.3171 28.3802 79.7383 31.3669 79.7383Z",
    fill: "#E9F0FF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M31.3669 53.7798C34.3537 53.7798 36.7749 51.3586 36.7749 48.3718C36.7749 45.3851 34.3537 42.9639 31.3669 42.9639C28.3802 42.9639 25.959 45.3851 25.959 48.3718C25.959 51.3586 28.3802 53.7798 31.3669 53.7798Z",
    fill: "#E9F0FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.2035 40.8015C33.3849 40.8015 36.7746 37.4117 36.7746 33.2303C36.7746 29.0489 33.3849 25.6592 29.2035 25.6592C25.022 25.6592 21.6323 29.0489 21.6323 33.2303C21.6323 37.4117 25.022 40.8015 29.2035 40.8015Z",
    fill: "#C9DBFF"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M77.334 83.0656C81.2168 83.0656 84.3644 79.918 84.3644 76.0352C84.3644 72.1525 81.2168 69.0049 77.334 69.0049C73.4513 69.0049 70.3037 72.1525 70.3037 76.0352C70.3037 79.918 73.4513 83.0656 77.334 83.0656Z",
    fill: "#E9F0FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M86.4723 49.4148C90.9524 49.4148 94.5842 45.783 94.5842 41.3029C94.5842 36.8228 90.9524 33.1909 86.4723 33.1909C81.9922 33.1909 78.3604 36.8228 78.3604 41.3029C78.3604 45.783 81.9922 49.4148 86.4723 49.4148Z",
    fill: "#C9DBFF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M57.678 109.571C61.2621 109.571 64.1676 106.666 64.1676 103.082C64.1676 99.4978 61.2621 96.5923 57.678 96.5923C54.0939 96.5923 51.1885 99.4978 51.1885 103.082C51.1885 106.666 54.0939 109.571 57.678 109.571Z",
    fill: "#C9DBFF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M74.9821 30.4583C78.1181 30.4583 80.6604 27.916 80.6604 24.7799C80.6604 21.6439 78.1181 19.1016 74.9821 19.1016C71.846 19.1016 69.3037 21.6439 69.3037 24.7799C69.3037 27.916 71.846 30.4583 74.9821 30.4583Z",
    fill: "#C9DBFF"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M60.0289 46.2908C64.509 46.2908 68.1409 42.6589 68.1409 38.1788C68.1409 33.6987 64.509 30.0669 60.0289 30.0669C55.5488 30.0669 51.917 33.6987 51.917 38.1788C51.917 42.6589 55.5488 46.2908 60.0289 46.2908Z",
    fill: "#F7FAFF"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M68.358 65.5163C72.8381 65.5163 76.47 61.8845 76.47 57.4044C76.47 52.9243 72.8381 49.2925 68.358 49.2925C63.8779 49.2925 60.2461 52.9243 60.2461 57.4044C60.2461 61.8845 63.8779 65.5163 68.358 65.5163Z",
    fill: "#E9F0FF"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M60.0289 85.2287C64.509 85.2287 68.1409 81.5969 68.1409 77.1168C68.1409 72.6367 64.509 69.0049 60.0289 69.0049C55.5488 69.0049 51.917 72.6367 51.917 77.1168C51.917 81.5969 55.5488 85.2287 60.0289 85.2287Z",
    fill: "#C9DBFF"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M44.345 40.8828C47.3317 40.8828 49.7529 38.4616 49.7529 35.4748C49.7529 32.4881 47.3317 30.0669 44.345 30.0669C41.3582 30.0669 38.937 32.4881 38.937 35.4748C38.937 38.4616 41.3582 40.8828 44.345 40.8828Z",
    fill: "#F7FAFF"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M44.345 53.8623C47.3317 53.8623 49.7529 51.4411 49.7529 48.4543C49.7529 45.4676 47.3317 43.0464 44.345 43.0464C41.3582 43.0464 38.937 45.4676 38.937 48.4543C38.937 51.4411 41.3582 53.8623 44.345 53.8623Z",
    fill: "#C9DBFF"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M44.345 79.8208C47.3317 79.8208 49.7529 77.3996 49.7529 74.4128C49.7529 71.4261 47.3317 69.0049 44.345 69.0049C41.3582 69.0049 38.937 71.4261 38.937 74.4128C38.937 77.3996 41.3582 79.8208 44.345 79.8208Z",
    fill: "#C9DBFF"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M18.9285 53.8623C21.9152 53.8623 24.3364 51.4411 24.3364 48.4543C24.3364 45.4676 21.9152 43.0464 18.9285 43.0464C15.9417 43.0464 13.5205 45.4676 13.5205 48.4543C13.5205 51.4411 15.9417 53.8623 18.9285 53.8623Z",
    fill: "#F7FAFF"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M31.3669 79.8208C34.3537 79.8208 36.7749 77.3996 36.7749 74.4128C36.7749 71.4261 34.3537 69.0049 31.3669 69.0049C28.3802 69.0049 25.959 71.4261 25.959 74.4128C25.959 77.3996 28.3802 79.8208 31.3669 79.8208Z",
    fill: "#E9F0FF"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M113.959 34.9497C116.946 34.9497 119.367 32.5285 119.367 29.5417C119.367 26.555 116.946 24.1338 113.959 24.1338C110.972 24.1338 108.551 26.555 108.551 29.5417C108.551 32.5285 110.972 34.9497 113.959 34.9497Z",
    fill: "#E9F0FF"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M31.3669 53.8623C34.3537 53.8623 36.7749 51.4411 36.7749 48.4543C36.7749 45.4676 34.3537 43.0464 31.3669 43.0464C28.3802 43.0464 25.959 45.4676 25.959 48.4543C25.959 51.4411 28.3802 53.8623 31.3669 53.8623Z",
    fill: "#E9F0FF"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M29.2039 40.884C33.3854 40.884 36.7751 37.4943 36.7751 33.3128C36.7751 29.1314 33.3854 25.7417 29.2039 25.7417C25.0225 25.7417 21.6328 29.1314 21.6328 33.3128C21.6328 37.4943 25.0225 40.884 29.2039 40.884Z",
    fill: "#C9DBFF"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M95.9955 72.486C100.177 72.486 103.567 69.0963 103.567 64.9149C103.567 60.7335 100.177 57.3438 95.9955 57.3438C91.814 57.3438 88.4243 60.7335 88.4243 64.9149C88.4243 69.0963 91.814 72.486 95.9955 72.486Z",
    fill: "#F7FAFF"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M138.714 61.4337C140.656 61.4337 142.23 59.8599 142.23 57.9185C142.23 55.9771 140.656 54.4033 138.714 54.4033C136.773 54.4033 135.199 55.9771 135.199 57.9185C135.199 59.8599 136.773 61.4337 138.714 61.4337Z",
    fill: "#C9DBFF"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M110.863 58.1897C115.343 58.1897 118.975 54.5578 118.975 50.0778C118.975 45.5977 115.343 41.9658 110.863 41.9658C106.383 41.9658 102.751 45.5977 102.751 50.0778C102.751 54.5578 106.383 58.1897 110.863 58.1897Z",
    fill: "#F7FAFF"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M126.277 61.4343C129.413 61.4343 131.955 58.8921 131.955 55.756C131.955 52.6199 129.413 50.0776 126.277 50.0776C123.141 50.0776 120.599 52.6199 120.599 55.756C120.599 58.8921 123.141 61.4343 126.277 61.4343Z",
    fill: "#C9DBFF"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M91.3841 109.557C96.9096 109.557 101.389 105.078 101.389 99.5526C101.389 94.0271 96.9096 89.5479 91.3841 89.5479C85.8587 89.5479 81.3794 94.0271 81.3794 99.5526C81.3794 105.078 85.8587 109.557 91.3841 109.557Z",
    fill: "#C9DBFF"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M97.0465 21.2511C99.5852 21.2511 101.643 19.1931 101.643 16.6544C101.643 14.1157 99.5852 12.0576 97.0465 12.0576C94.5077 12.0576 92.4497 14.1157 92.4497 16.6544C92.4497 19.1931 94.5077 21.2511 97.0465 21.2511Z",
    fill: "#E9F0FF"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M126.277 74.9544C129.413 74.9544 131.955 72.4121 131.955 69.276C131.955 66.1399 129.413 63.5977 126.277 63.5977C123.141 63.5977 120.599 66.1399 120.599 69.276C120.599 72.4121 123.141 74.9544 126.277 74.9544Z",
    fill: "#E9F0FF"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M138.443 87.3916C141.43 87.3916 143.851 84.9704 143.851 81.9836C143.851 78.9969 141.43 76.5757 138.443 76.5757C135.456 76.5757 133.035 78.9969 133.035 81.9836C133.035 84.9704 135.456 87.3916 138.443 87.3916Z",
    fill: "#F7FAFF"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M111.404 87.3916C114.391 87.3916 116.812 84.9704 116.812 81.9836C116.812 78.9969 114.391 76.5757 111.404 76.5757C108.417 76.5757 105.996 78.9969 105.996 81.9836C105.996 84.9704 108.417 87.3916 111.404 87.3916Z",
    fill: "#E9F0FF"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCorrelationsEmptyState);
export default __webpack_public_path__ + "static/media/correlationsEmptyState.e5f60f8d.svg";
export { ForwardRef as ReactComponent };